import script from "./CircleLimbo.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleLimbo.vue?vue&type=script&setup=true&lang=js"

import "./CircleLimbo.vue?vue&type=style&index=0&id=6069e239&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6069e239"]])

export default __exports__